var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanbanBoarddash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2824",
    "data-name": "Rectangle 2824",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13232",
    "data-name": "Group 13232",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M18,18H2V2H18ZM19,0H1A1,1,0,0,0,0,1V19a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M5.5,13h0a1,1,0,0,1-1-1V5a1,1,0,0,1,2,0v7a1,1,0,0,1-1,1",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M14.5,16h0a1,1,0,0,0,1-1V5a1,1,0,0,0-2,0V15a1,1,0,0,0,1,1",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13072",
    "data-name": "Path 13072",
    d: "M10,9h0a1,1,0,0,0,1-1V5A1,1,0,0,0,9,5V8a1,1,0,0,0,1,1",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanbanBoarddash);
export default __webpack_public_path__ + "static/media/kanban-boarddash.c5e99a7e02672f51eb499fd5afe76116.svg";
export { ForwardRef as ReactComponent };